import { KeysByExactValue } from './keys-by-exact-value';
import { LegacyOption } from './legacy-option';

export type Option<T> = {
  icon?: string | JSX.Element;
  id?: string;
  label: string;
  value: T;
};

export namespace Option {
  function fromItems<TItem, KValue extends keyof TItem>(
    items: TItem[] | null | undefined,
    config: {
      labelKey: KeysByExactValue<TItem, string>;
      valueKey: KValue;
    }
  ): Option<TItem[KValue]>[] {
    return items?.map((item): Option<TItem[KValue]> => {
      return {
        label: item[config.labelKey] as string,
        value: item[config.valueKey]
      };
    }) ?? [];
  }

  export function fromIdAndName(
    items: { id: string; name: string; }[] | null | undefined
  ): Option<string>[] {
    return fromItems(items, {
      labelKey: 'name',
      valueKey: 'id'
    });
  }

  export function fromLegacy<T>(
    oldOptions: LegacyOption<T>[] | null | undefined
  ): Option<T>[] {
    return fromItems(oldOptions, {
      labelKey: 'name',
      valueKey: 'value'
    });
  }

  export function fromStrings(items: string[] | null | undefined): Option<string>[] {
    return items?.map((item) => {
      return {
        label: item,
        value: item
      };
    }) ?? [];
  }

  export function toDropdownOptions<T extends number | string>(
    options: Option<T>[]
  ): Record<string, string> {
    return Object.fromEntries(options.map(({
      label,
      value
    }): [T, string] => {
      return [value, label];
    }));
  }
}
